export class AdditionalInformationModeConfig {
  [fieldKey: string]: {
    visible: boolean;
    visibilityRequirements?: VisibilityRequirement[];
    defaultValue?: any;
  }
}

export enum VisibilityRequirement {
  HAS_AC = 'HAS_AC',
  HAS_AC_OR_AC_MINI = 'HAS_AC_OR_AC_MINI'
}
